import styled, { hueToColor } from '@benzinga/themetron';
import { Slider } from 'antd';
import React from 'react';
import { Close } from '@benzinga/themed-icons';
export interface HuePickerProps {
  hue: number;
  setHue: (hue: number | null) => void;
  noDeselect?: boolean;
  steps?: number;
}
export const HuePicker: React.FC<HuePickerProps> = props => {
  const steps = Math.min(props.steps ?? 15, 359);
  const stepSize = 360 / steps;
  return (
    <HueSetupDiv>
      <ColorPickerDiv>
        <Slider
          handleStyle={{ backgroundColor: hueToColor(props.hue), borderColor: hueToColor(props.hue) }}
          max={360 - stepSize}
          min={0}
          onChange={(item: unknown) => {
            props.setHue(item as number);
          }}
          step={stepSize}
          tooltip={{ formatter: null }}
          value={props.hue || 0}
        />
      </ColorPickerDiv>
      {!props.noDeselect && (
        <button className="u-closeIcon" onClick={() => props.setHue(null)}>
          <Close title="Remove Hue" />
        </button>
      )}
    </HueSetupDiv>
  );
};

const HueSetupDiv = styled.div`
  display: flex;
  align-items: center;
`;

const ColorPickerDiv = styled.div`
  z-index: 100;
  top: calc(100% \+ 10px);
  width: 200px;
  box-sizing: border-box;
  right: 15px;
  background: 'none';
  padding: 15px 20px;
  margin: '0.5em';
  position: 'inherit';
  :before {
    content: '';
    position: absolute;
    right: 20px;
    bottom: 100%;
    border-style: solid;
    border-width: 0 10px 10px 10px;
    border-color: transparent transparent ${props => props.theme.colors.backgroundActive} transparent;
  }

  .ant-slider {
    margin: 0em !important;
  }

  .ant-slider-rail {
    background: linear-gradient(
      to right,
      hsla(0, 75%, 65%, 0.4) 0,
      hsla(22.5, 75%, 65%, 0.4) 6.66%,
      hsla(45, 75%, 65%, 0.4) 13.33%,
      hsla(67.5, 75%, 65%, 0.4) 20%,
      hsla(90, 75%, 65%, 0.4) 26.66%,
      hsla(112.5, 75%, 65%, 0.4) 33.33%,
      hsla(135, 75%, 65%, 0.4) 40%,
      hsla(157.5, 75%, 65%, 0.4) 46.66%,
      hsla(180, 75%, 65%, 0.4) 53.33%,
      hsla(202.5, 75%, 65%, 0.4) 60%,
      hsla(225, 75%, 65%, 0.4) 66.66%,
      hsla(247.5, 75%, 65%, 0.4) 73.33%,
      hsla(270, 75%, 65%, 0.4) 80%,
      hsla(292.5, 75%, 65%, 0.4) 86.66%,
      hsla(315, 75%, 65%, 0.4) 93.33%,
      hsla(337.5, 75%, 65%, 0.4) 100%
    ) !important;
  }

  .ant-slider-track {
    display: none !important;
  }
`;
